import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetQuotaTemplate as GetQuotaTemplateQuery,
    GetQuotaTemplate_quotasTemplate as QuotasTemplate,
} from 'nutshell-graphql-types';

import GET_QUOTA_TEMPLATE from '../queries/get-quota-template.graphql';

export const useGetQuotaTemplate = (): {
    quotasTemplate: QuotasTemplate | null;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {data, loading, error} = useQuery<GetQuotaTemplateQuery>(GET_QUOTA_TEMPLATE);

    return {
        quotasTemplate: data?.quotasTemplate ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
